import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { getOtherOptionsFromWindow } from "../utils";
/**
 * Get the default decision and respect essential group and legitimate interests.
 */

function getDefaultDecision() {
  var respectLegitimateInterests = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  var _getOtherOptionsFromW = getOtherOptionsFromWindow(),
      groups = _getOtherOptionsFromW.groups,
      essentialGroup = _getOtherOptionsFromW.essentialGroup;

  var _groups$filter = groups.filter(function (_ref) {
    var slug = _ref.slug;
    return slug === essentialGroup;
  }),
      _groups$filter2 = _slicedToArray(_groups$filter, 1),
      essentialGroupObj = _groups$filter2[0]; // We need always use the current essential group


  var result = _defineProperty({}, essentialGroupObj.id, essentialGroupObj.items.map(function (_ref2) {
    var id = _ref2.id;
    return id;
  }));

  if (respectLegitimateInterests) {
    var _iterator = _createForOfIteratorHelper(groups),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var group = _step.value;

        if (group === essentialGroupObj) {
          continue;
        }

        var ids = group.items.filter(function (_ref3) {
          var legalBasis = _ref3.legalBasis;
          return legalBasis === "legitimate-interest";
        }).map(function (_ref4) {
          var id = _ref4.id;
          return id;
        });

        if (ids.length) {
          result[group.id] = ids;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return result;
}

export { getDefaultDecision };